import { jsx as _jsx } from "react/jsx-runtime";
import styled, { createGlobalStyle, css, ThemeProvider as StyledComponentsThemeProvider, } from "styled-components";
import '../../assets/font/index.css';
import React, { useMemo } from "react";
export const ThemedGlobalStyle = createGlobalStyle `
    html {
        font-size: calc( 100vw / 1920 );
        width: 100vw;
        min-height: 100vh;
        scroll-behavior: smooth;
        background: #101D42;
        ${({ theme }) => theme.mediaWidth.upToSmall `
            font-size: calc( 100vw / 375 );
        `};
    }
    * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
    }
    a {
        text-decoration: none;
    }
    ul,
    li {
        list-style: none;
    }
    body {
        scroll-behavior: smooth;
    }
  `;
export const MEDIA_WIDTHS = {
    upToExtraSmall: 500,
    upToSmall: 720,
    upToMedium: 960,
    upToLarge: 1280
};
const mediaWidthTemplates = Object.keys(MEDIA_WIDTHS).reduce((accumulator, size) => {
    ;
    accumulator[size] = (a, b, c) => css `
        @media (max-width: ${MEDIA_WIDTHS[size]}px) {
          ${css(a, b, c)}
        }
      `;
    return accumulator;
}, {});
export function theme() {
    return {
        // media queries
        mediaWidth: mediaWidthTemplates,
        //rwd
        mobile: css `
        display: none;
        ${mediaWidthTemplates.upToSmall `display:inherit;`}
      `,
        desktop: css `
        ${mediaWidthTemplates.upToSmall `display:none;`}
      `,
        mobileHeaderHeight: '54px',
    };
}
export default function ThemeProvider({ children }) {
    const themeObject = useMemo(() => theme(), []);
    return _jsx(StyledComponentsThemeProvider, { theme: themeObject, children: children });
}
export const PcShowContainter = styled.div `
${({ theme }) => theme.mediaWidth.upToSmall `
  display: none;
`};
`;
export const MobileShowContainer = styled.span `
display: none;
${({ theme }) => theme.mediaWidth.upToSmall `
  display: block;
`};
`;
